import React, { useEffect, useRef, useState } from 'react';
import { default as consoleEvents } from "@pb/utils/consoleEvents";
import cn from 'classnames';
import FocusLockUI from 'react-focus-lock/UI';
import { sidecar } from 'use-sidecar';
import { NiBConstant } from '../../micro-apps/NotifyIfBack/helpers/constants';
import { getVariation } from '../../micro-apps/NotifyIfBack/helpers/optimizely';
import styles from './FocusTrap.module.scss';
import handleArrowKey from './helpers/handleArrowKey';
import handleClickOutside from './helpers/handleClickOutside';
const FocusLockSidecar = sidecar(() => import(/* webpackPrefetch: true */ 'react-focus-lock/sidecar'));
const FocusTrap = ({ disabled = false, children, onEscape, className, arrowKeyNavigationActivated, shouldAddOverlay = true, focusLockOverflow = 'auto', modalType, wrapperClassname, isDownloadAppBannerAccessible = false, id, }) => {
    const ref = useRef(null);
    const [isDownloadAppBannerVisibile, setIsDownloadAppBannerVisibile] = useState(false);
    useEffect(() => {
        const clickOutside = (event) => handleClickOutside({ current: ref.current, event, onEscape });
        const handleKeyDown = ({ key }) => {
            if (key === 'Escape') {
                return onEscape();
            }
            return handleArrowKey({ current: ref.current, arrowKeyNavigationActivated, key });
        };
        if (!disabled) {
            document.addEventListener('mousedown', clickOutside);
            document.addEventListener('keydown', handleKeyDown, true);
            if (isDownloadAppBannerAccessible) {
                getVariation([NiBConstant.VARIABLE_BANNER_OBJECT])
                    .then((data) => {
                    if (data === null || data === void 0 ? void 0 : data.flag) {
                        setIsDownloadAppBannerVisibile(data.flag);
                    }
                })
                    .catch((e) => {
                    consoleEvents.error('Error in Favorite and Cart Items On Sale component', e);
                });
            }
        }
        return () => {
            if (!disabled) {
                document.removeEventListener('mousedown', clickOutside);
                document.removeEventListener('keydown', handleKeyDown, true);
            }
        };
    }, [disabled]);
    const FocusComponent = disabled ? ({ children: child }) => React.createElement(React.Fragment, null, child) : FocusLockUI;
    return (React.createElement(React.Fragment, null,
        React.createElement(FocusComponent, { sideCar: FocusLockSidecar, returnFocus: true, className: cn(styles.focusLockContainer, focusLockOverflow === 'unset' && styles.focusLockOverflowUnset, modalType === 'middle' && styles.focusLockMiddleAlignment, isDownloadAppBannerVisibile && styles.maxWidth, wrapperClassname) },
            React.createElement("div", { role: "dialog", "aria-modal": "true", id: id, "data-hm-modal": "true", className: className, ref: ref }, children)),
        shouldAddOverlay && React.createElement("div", { className: cn(styles.focusTrapOverlay) })));
};
export default FocusTrap;
//# sourceMappingURL=FocusTrap.js.map